import React from 'react';

class ProgressBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            visible: false
        }
    }

    componentDidMount() {
        this.props.eventHandler.onIncrement(this.inc.bind(this));
        this.props.eventHandler.onStart(this.start.bind(this));
        this.props.eventHandler.onStop(this.stop.bind(this));
        if(this.props.test) {
            this.props.test();
        }
    }

    inc() {
        this.setState((prevState) => ({
            count: prevState.count + 1
        }));
    }

    start() {
        this.setState({
            count: 0,
            visible: true
        })
    }

    stop() {
        this.setState({
            visible: false,
            count : 0
        })
    }

    getWidth() {
        return (this.state.count / this.props.max) * 100 + '%';
    }

    render() {
        if(!this.state.visible) return null;
        return (
            <div className={'col-xs-8 col-xs-offset-2'} >
                <div className={'progress'} >
                    <div className={'progress-bar'} style={{ width: this.getWidth.bind(this)() }} />
                </div>
            </div>
        )
    }
}

export default ProgressBar;